import AreaCascader from 'comps/AreaCascader';
import useAreaCookie from 'hooks/useAreaCookie';
// import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { useContext, useState, useEffect } from 'react';
import { getFirstTownOfCityCode } from 'api/user';
import { cls } from 'reactutils';
// import { Checkbox } from 'antd';
import jsurl from 'jsurl';
import { UserContext } from 'libs/contexts';
import AgreementSelector from '@/biz-components/web/AgreementSelector';
import ContractSelector from '@/biz-components/web/ContractSelector';
import { useRouter } from 'next/router';
import { UserSource } from 'libs/enums';

export enum RadioType {
  ONLY_AGR = 'onlyShowAgreement', // 仅显示协议
  ALL_ADDRESS = 'showAllAddressId', // 显示所有地址
}

export default function ListRuleBar({ updateSearch }) {
  const router = useRouter();
  const userInfo = useContext(UserContext);
  // const site = useContext(SiteContext);
  const [areaLevelCode, setAreaLevelCode] = useState('');
  const [upstreamSupplierSysNoList, setUpstreamSupplierSysNoList] = useState([]);
  const primaryColor = 'var(--primaryColor)';
  const [radioStatus, setRadioStatus] = useState<Record<RadioType, boolean>>({
    [RadioType.ALL_ADDRESS]: false,
    [RadioType.ONLY_AGR]: false,
  });

  // 使用 useEffect 钩子，处理在路由参数变化时的操作
  useEffect(() => {
    const params = jsurl.parse(router.query.params);
    // 更新单选按钮状态
    setRadioStatus({
      [RadioType.ONLY_AGR]: params?.onlyShowAgreement ?? false,
      [RadioType.ALL_ADDRESS]: params?.showAllAddressId ?? false,
    });
    if (params?.upstreamSupplierSysNoList) {
      setUpstreamSupplierSysNoList(params?.upstreamSupplierSysNoList);
    }
  }, [router.query.params]);

  const { areaSysNo, setCookie, AREA_CODE_KEY, AREA_SYS_NO_KEY } = useAreaCookie();

  async function handleAreaChange(data: string[]) {
    if (!data || !data?.length) return;
    // 根据市 查询最后一级地区信息
    let res = await getFirstTownOfCityCode(data[data.length - 1]);
    if (res?.code === 200 && res?.data) {
      const { levelCode } = res.data;

      // 更新地区相关的状态和搜索参数
      setCookie(AREA_SYS_NO_KEY, res.data.sysNo);
      setCookie(AREA_CODE_KEY, levelCode);
      setAreaLevelCode(levelCode);
      updateSearch({
        areaLevelCode: levelCode,
        agreementSysNoList: [],
        contractAgreementSysNoList: [],
      });
    }
  }

  const { shopSysNo } = router.query;

  return (
    <>
      <div className="rule clearfix">
        <div className="rule-item addr">
          <div className="text">配送至</div>
          <div
            className={cls(
              'cascader',
              'rule-item',
              radioStatus.showAllAddressId && 'disabled-cascader',
            )}
          >
            <AreaCascader
              placeholder="请选择"
              value={areaSysNo}
              areaLevel={3}
              separator={''}
              onChange={handleAreaChange}
              trigger="click"
              disabled={radioStatus.showAllAddressId}
            />
          </div>
        </div>
        {userInfo?.organizationSource === UserSource.inside && (
          <>
            <AgreementSelector
              updateSearch={updateSearch}
              areaLevelCode={areaLevelCode}
              supplierSysNoList={upstreamSupplierSysNoList}
              shopSysNo={shopSysNo}
            />
            <ContractSelector
              updateSearch={updateSearch}
              areaLevelCode={areaLevelCode}
              supplierSysNoList={upstreamSupplierSysNoList}
            />
          </>
        )}

        {/* <div className="rule-checkbox">
          <Checkbox
            checked={radioStatus.showAllAddressId}
            onChange={(e: CheckboxChangeEvent) =>
              updateSearch({
                [RadioType.ALL_ADDRESS]: e.target.checked,
              })
            }
          >
            <span className="check-txt">显示全区域商品</span>
          </Checkbox>
        </div> */}

        {/* {userInfo && site?.mall?.enableSelectAllSkuOfBindAgreement === 0 && (
          <div className="rule-checkbox">
            <Checkbox
              checked={radioStatus.onlyShowAgreement}
              onChange={(e: CheckboxChangeEvent) =>
                updateSearch({
                  [RadioType.ONLY_AGR]: e.target.checked,
                })
              }
            >
              <span className="check-txt">
                {userInfo.isInside ? '仅显示已绑定交易规则的商品' : '仅展示可购买商品'}
              </span>
            </Checkbox>
          </div>
        )} */}
      </div>
      <style jsx>
        {`
        .rule {
            border: 1px solid #e8e8e8;
            display: flex;
            align-items: center;
          }
                .rule .rule-item.addr {
                    padding: 7px 20px;
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                  }
          
                  .rule-item.addr .text {
                    margin-right: 8px;
                    color: #999;
                    font-size: 12px;
                  }
          
                  .cascader {
                    position: relative;
                    display: inline-block;
                    min-width: 150px;
                    border: 1px solid #e8e8e8;
                    vertical-align: middle;
                    padding-left: 8px;
                    line-height: 24px;
                  }
                  .disabled-cascader {
                    background-color: #e4e7ed;
                    cursor: not-allowed;
                  }
                  .check-txt {
                    font-size: 12px;
                  }
          
                  .rule-checkbox :global(.ant-checkbox-checked::after) {
                    border-color: ${primaryColor};
                  }
          
                  .rule-checkbox :global(.ant-checkbox-checked .ant-checkbox-inner) {
                    background-color: ${primaryColor};
                    border-color: ${primaryColor};
                  }
          
                  .rule-checkbox
                    :global(
                      .ant-checkbox-wrapper:hover .ant-checkbox-inner,
                      .ant-checkbox:hover .ant-checkbox-inner,
                      .ant-checkbox-input:focus + .ant-checkbox-inner
                    ) {
                    border-color: ${primaryColor};
                  }
                `}
      </style>
    </>
  );
}
